module.exports = __webpack_public_path__ + "img/plus.be9a8c9e.svg";